export const loaderMap: Record<string, () => Promise<unknown>> = {
  de: () => import('./de.json'),
  en: () => import('./en.json'),
  fr: () => import('./fr.json'),
  it: () => import('./it.json'),
  nl: () => import('./nl.json'),
  es: () => import('./es.json'),
  cs: () => import('./cs.json'),
  sk: () => import('./sk.json'),
  da: () => import('./da.json'),
  pl: () => import('./pl.json')
};
